<template>
<div v-loading="loading">
  <el-image :preview-src-list="this.urls" @click="this.urls[0] =this.url" :src="this.url"></el-image>
</div>
</template>

<script>
export default {
  name: "PicInfo",
  props:{
    parentData: {
      type: Object,
      default: () => {
        return {
        }
      }
    },
  },
  data(){
    return{
      urls:[],
      loading:false,
      url:''
    }
  },
  methods:{

    async getImages(){
      this.loading = true
      let {data:res} = await this.$axios.post('/bus/zuliZhiJianRecord/getPics',this.parentData.id);
      if (res.code !== 0 || !res.data) {
        this.$message.error("查询失败！未找到图片")
      }else {
        this.urls = res.data
        this.url = this.urls[0]
      }
      this.loading = false
    }
  },
  created() {
    this.getImages()
  }
}
</script>

<style scoped>

</style>